

























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import SocialFriends from '@/components/SocialFriends.vue';
import arenaService from '../services/arena.service';
import optionsService from '../services/options.service';
import wizardService from '../services/wizard.service';
import authService from '../services/auth.service';

@Component({
  components: {
  },
})
export default class Social extends Vue {

  public data() {
    return {
      optionsDisplayed: false,
      optionsState: 'game',
      options: optionsService.options,
    };
  }

  public mounted() {
    // Events
    window.addEventListener('keydown', this.keydownHandler);
  }

  public async keydownHandler(e: KeyboardEvent) {
    if (e.code === 'Escape') {
      // Hide / display options
      this.$data.optionsDisplayed = !this.$data.optionsDisplayed;

      // Save options
      if (!this.$data.optionsDisplayed) {
        this.refreshOptions();
      }
    }
  }

  public async concede() {
    const gameId: number = parseInt(this.$route.query.gameId as string, 10);
    await arenaService.concede(gameId);
    this.$data.optionsDisplayed = false;
    this.$router.push('/');
  }

  public changeRealm() {
    this.$data.optionsDisplayed = false;
    this.$router.push('/select-realm');
  }

  public setGameTips(value: boolean) {
    optionsService.options.tip_play = value;
    optionsService.options.tip_matchmaking = value;
    optionsService.options.tip_game = value;
    optionsService.options.tip_fpe_2 = value;
    optionsService.options.tip_fpe_4 = value;
    optionsService.options.tip_fpe_6 = value;
    optionsService.options.tip_fpe_8 = value;
    optionsService.options.tip_fpe_9 = value;
    optionsService.options.tip_fpe_11 = value;
    optionsService.options.tip_fpe_15 = value;
    optionsService.options.tip_fpe_17 = value;
    optionsService.options.tip_cards_home = value;
    optionsService.options.tip_cards_deck = value;
    this.refreshOptions();
  }

  public refreshOptions() {
    optionsService.saveOptions();
    this.$i18n.locale = optionsService.options.language as string;
    if (optionsService.options.language && ['fr', 'en'].includes(optionsService.options.language)) {
      wizardService.setMe({
        publicRoom: optionsService.options.language as ('fr'|'en'),
      });
    }
  }

  public logout() {
    authService.logout();
    window.location.reload();
  }

  public get isInMatch() {
    const matchesPaths: string[] = [
      '/game',
    ];
    return matchesPaths.includes(this.$route.path);
  }

  public get isInMatchMaking() {
    const matchesPaths: string[] = [
      '/matchmaking',
    ];
    return matchesPaths.includes(this.$route.path);
  }

}
